import { useEffect, useRef } from "react";

const SCROLL_THRESHOLDS = [5, 10, 15, 20, 25, 50, 75, 100];

export const useScrollDepth = () => {
  const triggeredThresholds = useRef<Set<number>>(new Set());

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      const scrollPercentage = Math.round(
        ((scrollTop + windowHeight) / documentHeight) * 100
      );

      // Check each threshold
      SCROLL_THRESHOLDS.forEach((threshold) => {
        if (
          scrollPercentage >= threshold &&
          !triggeredThresholds.current.has(threshold)
        ) {
          // Mark as triggered
          triggeredThresholds.current.add(threshold);

          // Push to dataLayer
          if ((window as any).dataLayer) {
            (window as any).dataLayer.push({
              event: "scroll_depth",
              depth_percentage: threshold,
            });
          }

          if (import.meta.env.DEV) {
            console.log(`📊 Scroll depth: ${threshold}%`);
          }
        }
      });
    };

    // Add scroll listener
    window.addEventListener("scroll", handleScroll, { passive: true });

    // Initial check
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
};
